import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

export default function AccountSuspended() {
  const { logout } = useAuth();
  const [reason, setReason] = useState('');

  useEffect(() => {
    const stored = sessionStorage.getItem('suspension_reason') || '';
    setReason(stored);
  }, []);

  const handleSignOut = () => {
    logout();
    window.location.href = '/login';
  };

  return (
    <div style={s.page}>
      <div style={s.card}>

        <div style={s.iconWrap}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
            stroke="#dc2626" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>

        <h1 style={s.heading}>Account Suspended</h1>
        <p style={s.subheading}>
          Your account has been suspended and cannot be used at this time.
        </p>

        {reason ? (
          <div style={s.reasonBox}>
            <div style={s.reasonLabel}>Reason</div>
            <div style={s.reasonText}>{reason}</div>
          </div>
        ) : (
          <div style={s.reasonBox}>
            <div style={s.reasonLabel}>Reason</div>
            <div style={s.reasonText}>No reason was provided. Please contact support for details.</div>
          </div>
        )}

        <div style={s.divider} />

        <div style={s.supportBox}>
          <div style={s.supportTitle}>Need to appeal or get help?</div>
          <p style={s.supportText}>
            If you believe this suspension is a mistake, please contact our support team.
            Include your registered email address in your message.
          </p>
          <a href="mailto:support@visinvoke.com" style={s.supportLink}>
            support@visinvoke.com
          </a>
        </div>

        <button style={s.signOutBtn} onClick={handleSignOut}>
          Sign Out
        </button>

        <p style={s.footer}>
          Your account data is retained. This suspension does not delete your account.
        </p>

      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1e1b4b 0%, #334155 50%, #881337 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Segoe UI', sans-serif",
    padding: '32px 16px',
  },
  card: {
    background: '#ffffff',
    borderRadius: 20,
    padding: '52px 48px',
    maxWidth: 520,
    width: '100%',
    boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 0,
  },
  iconWrap: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    background: '#fef2f2',
    border: '2px solid #fecaca',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
    flexShrink: 0,
  },
  heading: {
    fontSize: 28,
    fontWeight: 800,
    color: '#111827',
    margin: '0 0 10px',
  },
  subheading: {
    fontSize: 16,
    color: '#6b7280',
    lineHeight: 1.6,
    margin: '0 0 24px',
  },
  reasonBox: {
    width: '100%',
    background: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: 10,
    padding: '16px 20px',
    textAlign: 'left',
    marginBottom: 24,
  },
  reasonLabel: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: '#dc2626',
    marginBottom: 6,
  },
  reasonText: {
    fontSize: 15,
    color: '#374151',
    lineHeight: 1.55,
    fontWeight: 500,
  },
  divider: {
    width: '100%',
    height: 1,
    background: '#f3f4f6',
    marginBottom: 24,
  },
  supportBox: {
    width: '100%',
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: 10,
    padding: '16px 20px',
    textAlign: 'left',
    marginBottom: 28,
  },
  supportTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: '#111827',
    marginBottom: 8,
  },
  supportText: {
    fontSize: 14,
    color: '#6b7280',
    lineHeight: 1.6,
    margin: '0 0 10px',
  },
  supportLink: {
    fontSize: 14,
    color: '#7c3aed',
    fontWeight: 600,
    textDecoration: 'none',
  },
  signOutBtn: {
    background: '#f3f4f6',
    color: '#374151',
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    padding: '12px 32px',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    marginBottom: 20,
  },
  footer: {
    fontSize: 12,
    color: '#9ca3af',
    margin: 0,
  },
};
